export default "__VITE_ASSET__H7pUtBor__"